<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="ch00_fm03_copy"></a><a id="page_iv"></a>Copyright © 2011 Fordham University Press</p>
<p class="copyright">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.</p>
<p class="copyright">Fordham University Press has no responsibility for the persistence or accuracy of URLs for external or third-party Internet websites referred to in this publication and does not guarantee that any content on such websites is, or will remain, accurate or appropriate.</p>
<p class="copyright">Fordham University Press also publishes its books in a variety of electronic formats. Some content that appears in print may not be available in electronic books.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Seraile, William, 1941–</p>
<p class="copyright1">Angels of mercy : white women and the history of New York’s Colored Orphan<br/>Asylum / William Seraile.—1st ed.</p>
<p class="copyright1">    p. cm.</p>
<p class="copyright1">Includes bibliographical references and index.</p>
<p class="copyright1">ISBN 978-0-8232-3419-6 (cloth : alk. paper)</p>
<p class="copyright1">1. Colored Orphan Asylum and Association for the Benefit of Colored Orphans (New York, N.Y.)—History. 2. Women philanthropists—New York (State)—New York— History. 3. Women, White—New York (State)—New York—History. I. Title. HV995.N52C657    2011 362.73′2—dc22</p>
<p class="copyright2">2011006835</p>
<p class="copyright">Printed in the United States of America<br/>13 12 11 5 4 3 2 1<br/>First edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_copy.vue?2c2b26db